import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('ajax:success', this.handleSuccess.bind(this))
    this.element.addEventListener('ajax:error', this.handleError.bind(this))
    this.element.addEventListener('ajax:beforeSend', this.validateBeforeSend.bind(this))
    
    const submitButton = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (submitButton) {
      submitButton.addEventListener('click', this.validateButtonClick.bind(this), true)
    }
    
    const minLimitField = this.element.querySelector('input[name*="[min_limit]"]')
    const maxLimitField = this.element.querySelector('input[name*="[max_limit]"]')
    
    if (minLimitField && maxLimitField) {
      minLimitField.addEventListener('input', this.validateLimits.bind(this))
      maxLimitField.addEventListener('input', this.validateLimits.bind(this))
    }
  }
  
  validateButtonClick(event) {
    if (!this.isValid()) {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()
      return false
    }
  }
  
  validateBeforeSend(event) {
    if (!this.isValid()) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }
  
  isValid() {
    const minLimitField = this.element.querySelector('input[name*="[min_limit]"]')
    const maxLimitField = this.element.querySelector('input[name*="[max_limit]"]')
    
    if (!minLimitField || !maxLimitField) return true
    
    const minLimit = minLimitField.value ? parseInt(minLimitField.value, 10) : null
    const maxLimit = maxLimitField.value ? parseInt(maxLimitField.value, 10) : null
    
    if (minLimit !== null && maxLimit !== null && maxLimit <= minLimit) {
      this.showNotification('Maximum limit must be greater than minimum limit', 'error')
      this.highlightInvalidFields(minLimitField, maxLimitField)
      return false
    }
    
    return true
  }
  
  validateLimits() {
    const minLimitField = this.element.querySelector('input[name*="[min_limit]"]')
    const maxLimitField = this.element.querySelector('input[name*="[max_limit]"]')
    
    if (!minLimitField || !maxLimitField) return
    
    const minLimit = minLimitField.value ? parseInt(minLimitField.value, 10) : null
    const maxLimit = maxLimitField.value ? parseInt(maxLimitField.value, 10) : null
    
    if (minLimit !== null && maxLimit !== null && maxLimit <= minLimit) {
      minLimitField.style.borderColor = '#dc3545'
      maxLimitField.style.borderColor = '#dc3545'
    } else {
      this.clearFieldErrors(minLimitField, maxLimitField)
    }
  }
  
  highlightInvalidFields(minField, maxField) {
    minField.style.borderColor = '#dc3545'
    maxField.style.borderColor = '#dc3545'
    
    this.removeFieldErrorMessages()
    
    const errorMsg = document.createElement('div')
    errorMsg.className = 'field-error'
    errorMsg.style.cssText = 'color: #dc3545; font-size: 12px; margin-top: 5px;'
    errorMsg.textContent = 'Maximum limit must be greater than minimum limit'
    
    const maxFieldContainer = maxField.closest('.field')
    if (maxFieldContainer && !maxFieldContainer.querySelector('.field-error')) {
      maxFieldContainer.appendChild(errorMsg)
    }
  }
  
  clearFieldErrors(minField, maxField) {
    if (minField) minField.style.borderColor = ''
    if (maxField) maxField.style.borderColor = ''
    this.removeFieldErrorMessages()
  }
  
  removeFieldErrorMessages() {
    const errorMessages = this.element.querySelectorAll('.field-error')
    errorMessages.forEach(msg => msg.remove())
  }

  handleSuccess(event) {
    const [data, status, xhr] = event.detail

    if (!data || !data.success) {
      this.showNotification('Error updating limits', 'error')
      return
    }

    const match = this.element.action.match(/kanban_lists\/(\d+)/)
    if (!match) {
      console.warn('Could not extract kanban_list ID from form action')
      return
    }
    const kanbanListId = match[1]

    const kanbanList = document.querySelector(`#kanban-list-${kanbanListId}`)
    if (!kanbanList) {
      console.warn(`No kanban list element for #kanban-list-${kanbanListId}`)
      return
    }

    if (data.header_html) {
      const header = kanbanList.querySelector('.kanban-list-header')
      if (header) {
        header.innerHTML = data.header_html
      }
    }

    this.showNotification('Limits updated successfully', 'success')

    const showHide = this.element.closest('.show-hide')
    if (showHide) {
      const trigger = showHide.querySelector('.toggle-inner a')
      if (trigger) trigger.click()
    }
  }

  handleError(event) {
    const [data, status, xhr] = event.detail
    this.showNotification('Error updating limits', 'error')
  }

  showNotification(message, type) {
    console.log(`[${type}] ${message}`)
  }
}
